/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Col_NoInputs */

const vi_receipt_col_no = /** @type {(inputs: Receipt_Col_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TT`)
};

/**

* @param {Receipt_Col_NoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_col_no = /** @type {((inputs?: Receipt_Col_NoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Col_NoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_col_no(inputs)
});